import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker, captureInstallPrompt } from "@/pwa";

// Capture the browser's install prompt AS EARLY AS POSSIBLE — Chrome only
// fires beforeinstallprompt once per page load, so we must be listening
// before React finishes hydrating.
captureInstallPrompt();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register the service worker AFTER first paint so the initial TTI is
// unaffected. The util itself defers to window 'load'.
registerServiceWorker();
